var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 0C9.7 0 8.4 0.5 7.5 1.5L6.3 2.6C5.9 3 5.9 3.6 6.3 4C6.7 4.4 7.3 4.4 7.7 4L8.9 2.8C10 1.7 12 1.7 13.1 2.8C13.7 3.4 14 4.2 14 5C14 5.8 13.7 6.6 13.1 7.1L12 8.3C11.6 8.7 11.6 9.3 12 9.7C12.2 9.9 12.5 10 12.7 10C12.9 10 13.2 9.9 13.4 9.7L14.6 8.5C15.5 7.6 16 6.3 16 5C16 3.7 15.5 2.4 14.5 1.5C13.6 0.5 12.3 0 11 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.3 12L7.1 13.2C6 14.3 4 14.3 2.9 13.2C2.3 12.6 2 11.8 2 11C2 10.2 2.3 9.4 2.9 8.9L4 7.7C4.4 7.3 4.4 6.7 4 6.3C3.6 5.9 3 5.9 2.6 6.3L1.5 7.5C0.5 8.4 0 9.7 0 11C0 12.3 0.5 13.6 1.5 14.5C2.4 15.5 3.7 16 5 16C6.3 16 7.6 15.5 8.5 14.5L9.7 13.3C10.1 12.9 10.1 12.3 9.7 11.9C9.3 11.5 8.7 11.6 8.3 12Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.40002 5.19999L5.20002 9.39999C4.80002 9.79999 4.80002 10.4 5.20002 10.8C5.40002 11 5.70002 11.1 5.90002 11.1C6.10002 11.1 6.40002 11 6.60002 10.8L10.8 6.59999C11.2 6.19999 11.2 5.59999 10.8 5.19999C10.4 4.79999 9.80002 4.79999 9.40002 5.19999Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.ffdd3c09.svg";
export { ForwardRef as ReactComponent };